const THEME_STORAGE_KEY = "theme";

const isThemeValue = (value) => value === "light" || value === "dark";

export const getStoredTheme = () => {
  if (typeof window === "undefined") return null;

  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isThemeValue(saved) ? saved : null;
  } catch {
    return null;
  }
};

export const getPreferredTheme = () => {
  const stored = getStoredTheme();
  if (stored) return stored;

  if (typeof window !== "undefined") {
    try {
      if (window.matchMedia?.("(prefers-color-scheme: dark)")?.matches) {
        return "dark";
      }
    } catch {}
  }

  return "light";
};

export const applyTheme = (theme) => {
  if (typeof document === "undefined") return;

  const resolvedTheme = isThemeValue(theme) ? theme : "light";
  const root = document.documentElement;
  const isDark = resolvedTheme === "dark";

  root.classList.toggle("dark", isDark);
  root.classList.toggle("light", !isDark);
  root.setAttribute("data-theme", resolvedTheme);
  root.style.colorScheme = resolvedTheme;
};

export const persistTheme = (theme) => {
  const resolvedTheme = isThemeValue(theme) ? theme : "light";

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, resolvedTheme);
    } catch {}
  }

  applyTheme(resolvedTheme);
};

export { THEME_STORAGE_KEY };
